import { ServiceBase } from './service_base.js';

/**
 * A service to manage the application.
 */
class AppService extends ServiceBase {
  schedule(service) {
    return this.get(`/${service}`);
  }
}

export { AppService };
